import React, { useState } from "react";
import { Question } from "../types";
import { deleteSurveyQuestion } from "../Firebase/utils";
import { deleteQuestion } from "../store/features/CreateSurveySlice";
import { useAppDispatch, useAppSelector } from "../store/store";
import MultipleSelectionForm from "./MultipleSelectionForm";
import { TbArrowBadgeRightFilled } from "react-icons/tb";
import QuestionPreviewContainer from "./QuestionPreviewContainer";
import useDeleteSurveyQuestion from "../CustomHooks/useDeleteSureveyQuestion";

interface MultipleSelectionOptionsPreviewDisplayProps {
    question: Question;
    questionText: string;
    options: string[];
}

export default (props: MultipleSelectionOptionsPreviewDisplayProps) => {

    const { question, questionText, options } = props;
    const dispatch = useAppDispatch();
    const user = useAppSelector(state => state.user.user);
    const survey = useAppSelector(state => state.survey.survey);
    const [ modalOpen, setModalOpen ] = useState<boolean>(false);
    
    const { deleteQuestion, loading, error } = useDeleteSurveyQuestion(survey, question);

    const handleEditQuestion = () => {
        setModalOpen(true);
        // try{
        //     updateSurveyQuestion(user, survey, question);
        //     dispatch(updateQuestion(question));
        // }catch(err){
        //     console.error(err);
        // }        
    }

    return (
        <QuestionPreviewContainer question={question} handleDeleteQuestion={() => deleteQuestion()} handleEditQuestion={handleEditQuestion}>
            <div className="flex flex-col gap-4">
            <ul className="flex flex-col gap-5">
                    {options.map((option: string) => {
                        return (
                            <li key={option} className="flex items-center gap-2 text-xl"><TbArrowBadgeRightFilled className="text-[#3da8e2] text-3xl"/>{option}</li>
                        );
                    })}
                </ul>
            </div>
            <MultipleSelectionForm openState={modalOpen} onClose={() => { setModalOpen(false) }} question={question}/>
        </QuestionPreviewContainer>
    )
}